import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import UploadReport from "./uploadReport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { Pagination } from "react-bootstrap";

function EmployeesAppointmentsDetails() {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
    const [lab, setLab] = useState(null);


  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("data")).token;
  const orgcode = JSON.parse(localStorage.getItem("data")).orgcode;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm]); 

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
  
    try {
      
      const response = await axios.get(`/api/employeeappointment/getAllAppointments`, {
        params: { labId: lab?.id, query: searchTerm, page: pageNumber, size: 12 },
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setAppointmentDetails(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };
  
  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
        const labRes = await axios.get(`/api/labdetails/labcode=${orgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      setLab(labRes.data);
      const trans = await axios.get(`/api/employeeappointment/getAllAppointments/labId=${labRes.data?.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  const handleCancelClick = async (appointment) => {
    setSelectedAppointment(appointment)
    setIsCancelPopupOpen(true);
  };
  
  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };


  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    getData();
  };
 
  const [pdfUrl, setPdfUrl] = useState(null);
  const handleViewPdf = async (appointmentId) => {
  const token = JSON.parse(localStorage.getItem("data")).token;
  await axios({
    url: `/api/employeeappointment/download/id=${appointmentId}`,
    method: "GET",
    responseType: "blob",
    headers: { Authorization: `Bearer ${token}` },
  }).then((response) => {
    console.log("filedata;", response);
    const contentType = response.headers["content-type"];
    let extension = "";

    // Determine the file extension based on content type
    if (contentType.includes("application/pdf")) {
      extension = "pdf";
    } else if (contentType.includes("image/jpeg")) {
      extension = "jpg";
    } else if (contentType.includes("image/png")) {
      extension = "png";
    } else {
      console.error("Unsupported file type:", contentType);
      return;
    }

    // Create a blob URL and download link for the file
    const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `file.${extension}`);
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  });
}


  useEffect(() => {
    if (appointmentDetails.length > 0) {
      const filtered = appointmentDetails.filter(
        (appointment) =>
          (appointment.company?.companyname?.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (appointment.pack?.packagename?.toLowerCase().includes(searchTerm.toLowerCase())) ||
          (String(appointment.emplo?.phoneno)?.toLowerCase().includes(searchTerm.toLowerCase()))
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, appointmentDetails]);

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }


  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
      setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };
  const handleAcceptAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoader(true);
    try {
      await axios.post(
        "/api/employeeappointment/accept-or-reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
      setLoader(false);
    } catch (error) {
    setLoader(false);
      handleError(error);
 
    }
  };


  const handleFetchReport= async (appointment) => {
    setLoader(true); 
    const token = JSON.parse(localStorage.getItem('data')).token;

    try {
      await axios.post('/api/employeeappointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
     handleError(error);
    } finally {
      setLoader(false); 
    }
  };

  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


  return (
    <div>
      <div>
        <AdminDashboard />
      </div>
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              <span>Appointment Details</span>
              <div className="form-group position-relative" style={{ width: '300px' }}>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by company or phone number or Package"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ paddingLeft: "2rem", width: "100%" }}
                />
                <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </div>
            </div>
            <br />
            <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                    <th>Sl.No.</th>
                  <th>Name</th>
                  <th>Date</th>
                  <th>Company</th>
                  <th>Contact Number</th>
                  <th>Package Name</th>
                  <th>Status</th>
                  <th>Report</th>
                  <th>Order Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  filteredData.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td>{index + 1}</td>
                      <td
                         style={{
                           cursor: (
                                    appointment.appStatus?.appointmentStatus === 'APPOINTMENT CANCELLED' || 
                                    appointment.appStatus?.appointmentStatus === 'APPOINTMENT COMPLETED') 
                                   ? "default" 
                                   : "pointer",
                         }}
                         title="Upload Report"
                         onClick={() => {
                           if (
                             appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                             appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
                           ) {
                             handleUploadReport(appointment.id);
                           }
                         }}
                         onMouseOver={(e) => {
                           if (
                             appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                             appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
                           ) {
                             e.target.style.color = "blue";
                             e.target.style.textDecoration = "underline";
                           }
                         }}
                         onMouseOut={(e) => {
                           e.target.style.color = "";
                           e.target.style.textDecoration = "";
                         }}
                       >
                       {appointment.fam?.name ? (
                                                 appointment.fam.name
                                               ) : (
                                                 <>
                                                 {appointment.emplo?.name} {appointment.emplo?.lastname}
                                               </>
                                               )}
                       
                      </td>
                      <td>{appointment.date}</td>
                      {/* <td>{appointment.time}</td> */}
                      <td>{appointment.company.companyname}</td>
                      <td>{appointment.emplo?.phoneno}</td>
             <td>  {appointment.pack!==null && (
                                               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                                                             <span style={{
                                                               backgroundColor: '#405469ff',
                                                               color: 'white',
                                                               padding: '6px 12px',
                                                               borderRadius: '20px',
                                                               fontWeight: '500',
                                                               display: 'inline-block',
                                                               fontSize: '14px'
                                                             }}>{appointment.pack?.packagename}</span>
                                                             <FiInfo
                                                                onClick={() => openTestsModal(appointment.packageid)}
                                                               style={{
                                                                 cursor: 'pointer',
                                                                 fontSize: '24px',
                                                               }}
                                                             />
                                                            </div>
             )}
                                               
                                      <div>
                                         {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                                           <>
                                       Additional Tests:
                                        <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                 {
                                   appointment.additionalTest.map((test, i) => (
                                     <li key={i}>{test.testDetails?.testname}</li>
                                   ))
                             
                                 }
                               </ul>
                               </>
                                         )}
                                      </div>
                                               </td>
                      <td>
  <div>{appointment.appStatus?.appointmentStatus}</div>
  {(appointment.appointmentstatus!=='APPOINTMENT CANCELLED'||appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED') && (appointment.appointmentstatus!=='APPOINTMENT COMPLETED'||appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
  // {(appointment.appointmentstatus!=='CANCELLED') && (appointment.appointmentstatus!=='COMPLETED') && (
  <>
    <div>
      {(appointment.appStatus?.appointmentStatus === 'APPOINTMENT CONFIRMATION PENDING WITH LAB')|| 
       (appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED' && 
        (appointment.appStatus?.updatedBy !== 'Lab')&&(appointment.appStatus?.updatedBy !== 'Lab Corporate')) ? (
        <button
          className="btn btn-success btn-sm rounded-pill me-1"
          onClick={() => handleAcceptAppointment(appointment.id)}
        >
          Accept
        </button>
      ) : null}

      <button
        className="btn btn-danger btn-sm rounded-pill"
        onClick={() => handleCancelClick(appointment)}
      >
        Cancel
      </button>
    </div>
    <div className="mt-2">
      <button
        className="btn btn-warning btn-sm rounded-pill"
        onClick={() => handleRescheduleAppointment(appointment.id)}
      >
        Reschedule
      </button>
    </div>
  </>
)}
</td>
<td>
{appointment.orderStatus ? (
    appointment.orderStatus?.appointmentReport ? (
      appointment.reportstatus === 'APPROVED' ? (
        <div>
          {/* Display the appointment report as a link if approved */}
          <a
            href={appointment.orderStatus.appointmentReport}
            target="_blank"
            rel="noopener noreferrer"
          >
            View Report
          </a>
        </div>
      ) : (
      "APPROVAL PENDING"
      )
    ) : (
      <button onClick={() => handleFetchReport(appointment)}>
        Fetch Report
      </button>
    )
  ) : (
    appointment.reportstatus ? (
      appointment.reportstatus === 'APPROVED' ? (
        <button
          className="btn btn-primary"
          onClick={() => handleViewPdf(appointment.id)}
        >
          View
        </button>
      ) : (
        "APPROVAL PENDING"
      )
    ) : (
      "No Report Added"
    )
  )}
</td>

<td>
  <div>{appointment.orderStatus?.status}</div>

  <div>
    {appointment.orderStatus ? (
      <>
      <br/>
        {appointment.orderStatus?.orderId === "" || appointment.orderStatus?.orderId == null ? (  // Check for both empty string and null/undefined
          <>
            {/* <button
              onClick={() => handleRetry(appointment)}
              style={{ cursor: 'pointer', color: 'red' }}
            >
              Retry
              <FaRedoAlt />
            </button> */}
          </>
        ) : (
          <div>{appointment.orderStatus?.orderId}</div>
        )}
      </>
    ) : (
      <div>NA</div>
    )}
  </div>
</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            </div>
            <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
          </div>
        </div>
        {isUploadModalOpen && (
          <UploadReport
            isOpen={isUploadModalOpen}
            onRequestClose={handleCloseUploadModal}
            empId={selectedAppointmentId}
          />
        )}

{isTestsModalOpen && (
            <TestForPackage
                    isOpen={isTestsModalOpen}
                    onRequestClose={closeTestsModal}
                    packageId={selectedPackage}
                  />
            )}


{isCancelPopupOpen &&(
   <FamilyAppointmentCancel
   isOpen={isCancelPopupOpen}
   onRequestClose={handleCloseCancelPopup}
   appointment={selectedAppointment}
 />
)}
  {isReschedulePopupOpen && (
          <AppointmentReschedule
            isOpen={isReschedulePopupOpen}
            onRequestClose={handleCloseReschedulePopup}
            appointmentId={selectedAppointmentId}
          />
        )}

        {loader && <div className="loading"></div>}
      </div>
    </div>
  );
}

export default EmployeesAppointmentsDetails;
